module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-1280x800.95c7624e.jpg";